import { render, staticRenderFns } from "./PaymentsDashboardSection.vue?vue&type=template&id=23e73cb0&scoped=true&"
import script from "./PaymentsDashboardSection.vue?vue&type=script&lang=js&"
export * from "./PaymentsDashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsDashboardSection.vue?vue&type=style&index=0&id=23e73cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e73cb0",
  null
  
)

export default component.exports